import React from "react";
import { Box, IconButton } from "@mui/material";
import { socialMediaBox } from "../styles/styles";
import { socialMediaIcons } from "../data/database";

const SocialMediaBar = () => {
  return (
    <Box sx={socialMediaBox}>
      {socialMediaIcons.map((item, index) => (
        <IconButton key={index}>
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <img
              src={item.icon}
              alt={item.label}
              style={{
                width: "1rem",
              }}
            />
          </a>
        </IconButton>
      ))}
    </Box>
  );
};

export default SocialMediaBar;
